module.exports = __webpack_public_path__ + "img/annihilation.a4a72f8d.svg";